import BaseLayout from 'es6/components/memory-bank/layouts/base-layout';
import { t } from 'es6/services/localization';

// All the nodes fall in the center.
const OriginY = 173;
const OriginXEasy = 107;
const OriginXModerate = 322;
const OriginXHard = 537;
const OriginXVeryHard = 752;

const LABELS = [
  {
    text: t('easy-label'),
    x: OriginXEasy,
    y: 15,
    dy: '0.5em',
    class: 'label label-middle label-easy',
  },

  {
    text: t('moderate-label'),
    x: OriginXModerate,
    y: 15,
    dy: '0.5em',
    class: 'label label-middle label-moderate',
  },

  {
    text: t('hard-label'),
    x: OriginXHard,
    y: 15,
    dy: '0.5em',
    class: 'label label-middle label-hard',
  },

  {
    text: t('very-hard-label'),
    x: OriginXVeryHard,
    y: 15,
    dy: '0.5em',
    class: 'label label-middle label-very-hard',
  },
];

const SECTIONS = {
  easy: {
    originX: OriginXEasy,
    originY: OriginY,
  },

  moderate: {
    originX: OriginXModerate,
    originY: OriginY,
  },

  hard: {
    originX: OriginXHard,
    originY: OriginY,
  },

  'very-hard': {
    originX: OriginXVeryHard,
    originY: OriginY,
  },
};

export default class Difficulty extends BaseLayout {
  get labels() {
    return LABELS;
  }

  /**
   * These sections contain an originX and originY field, which are
   * primarily used to determine the center of gravity for their sections.
   */
  get sections() {
    return SECTIONS;
  }
}
